import { checkAndGetArray } from 'src/common/helpers/array-helper';
import { CardData } from 'src/common/interfaces/dtos/IPreTenderAdd';
import { ReceiptData } from 'src/devices/payment/dtos/eps-data';

export const buildReceipts = (card: CardData, receipts: ReceiptData[]): void => {
  const merchantReceipt = checkAndGetArray(receipts)
    .filter(receiptData => receiptData.receiptType === 'Merchant')
    .flatMap((receiptData: ReceiptData) => receiptData.receiptLines);
  if (merchantReceipt.length) {
    card.merchantReceipt = merchantReceipt;
  }

  // Currently the merchant receipt is sent twice, once as the drawer receipt and once as the customer receipt
  const customerReceipt = checkAndGetArray(receipts)
    .filter(receiptData => receiptData.receiptType === 'Merchant')
    .flatMap((receiptData: ReceiptData) => receiptData.receiptLines);
  if (customerReceipt.length) {
    card.customerReceipt = customerReceipt;
  }
};
